export interface ISupplierReport {
  id: number;
  code: string;
  name: string;
}
